import React from 'react'
import PropTypes from 'prop-types'
import { Icon, ToggleButton, ToggleButtonGroup as TGBMUI, Typography } from '@mui/material'
import { mainWhite, mediumGrey } from 'utils/constants/ColorTheme'
import { LARGE_RADIUS } from 'utils/constants/Theme'

const ToggleButtonGroup = ({
    buttons = [],
    value,
    onChange,
    readMode = false,
}) => {
    const selectedButton = buttons.find(b => b.value === value)

    return (
        <TGBMUI
            color='mainWhite'
            value={value}
            exclusive
            onChange={(_, v) => !readMode && onChange(v)}
            sx={{
                border: 'solid 1px',
                borderColor: selectedButton?.color || mediumGrey,
                borderRadius: LARGE_RADIUS,
                overflow: 'hidden',
            }}
        >
            {buttons.map(button => (
                <ToggleButton
                    key={`TGB_${button.value}`}
                    value={button.value}
                    sx={{
                        pointerEvents: readMode && 'none',
                        padding: '3px 6px',
                        '&.Mui-selected, &.Mui-selected:hover, &.Mui-selected:focus': {
                            backgroundColor: button?.color,
                        },
                        ':focus': {
                            backgroundColor: mainWhite,
                        },
                        '&.MuiToggleButtonGroup-middleButton': {
                            borderLeft: `solid 1px ${selectedButton?.color || mediumGrey}`,
                            borderRight: `solid 1px ${selectedButton?.color || mediumGrey}`,
                        },
                        '&.MuiToggleButtonGroup-lastButton': {
                            borderLeft: `solid 1px ${selectedButton?.color || mediumGrey}`,
                        },
                        border: 'none',
                    }}
                >
                    {button.icon && (<><Icon>{button.icon}</Icon>&nbsp;</>)}
                    <Typography sx={{ textTransform: 'none', letterSpacing: 'none', fontSize: 14 }}>{button.name}</Typography>
                </ToggleButton>
            ))}
        </TGBMUI>
    )
}

ToggleButtonGroup.propTypes = {
    buttons: PropTypes.arrayOf(PropTypes.shape({
        value: PropTypes.string.isRequired,
        color: PropTypes.string,
        icon: PropTypes.string,
        name: PropTypes.string,
    })),
    value: PropTypes.string,
    onChange: PropTypes.func,
    readMode: PropTypes.bool,
}

export default ToggleButtonGroup